var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"overview-card"},[_c('div',{staticClass:"overview-box"},[_c('div',{staticClass:"overview-icon"},[_c('div',{staticClass:"overview-text-title"},[_vm._v(_vm._s(this.title))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }